const RECURRING_PAID_PLANS = new Set(['basic', 'pro', 'pro_ultra']);

export const normalizeSubscriptionType = (profile) => {
  if (!profile?.subscription_type) return '';
  return String(profile.subscription_type).trim().toLowerCase();
};

export const getSubscriptionExpiryDate = (profile) => {
  const rawValue = profile?.subscription_expires_at;
  if (!rawValue) return null;

  const parsed = rawValue instanceof Date ? rawValue : new Date(rawValue);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
};

export const isExamPassActive = (profile, now = new Date()) => {
  if (normalizeSubscriptionType(profile) !== 'exam_pass') return false;

  const expiryDate = getSubscriptionExpiryDate(profile);
  if (!expiryDate) return false;

  return expiryDate.getTime() > now.getTime();
};

export const hasActivePaidAccess = (profile, now = new Date()) => {
  const subscriptionType = normalizeSubscriptionType(profile);
  if (RECURRING_PAID_PLANS.has(subscriptionType)) return true;
  return isExamPassActive(profile, now);
};

export const isExpiredAccessPlan = (profile, now = new Date()) => {
  const subscriptionType = normalizeSubscriptionType(profile);
  if (subscriptionType !== 'exam_pass') return false;
  return !isExamPassActive(profile, now);
};

export const getPlanDisplayName = (profile) => {
  const subscriptionType = normalizeSubscriptionType(profile);
  if (subscriptionType === 'basic') return 'Basic';
  if (subscriptionType === 'pro') return 'Pro';
  if (subscriptionType === 'pro_ultra') return 'Pro Ultra';
  if (subscriptionType === 'exam_pass') return 'Exam Pass';
  return 'Free';
};

export { RECURRING_PAID_PLANS };
